export const getBackgroundServiceInstance = async () => {
    const { getBackgroundService } = await import('../../../core/services/BackgroundService.js');
    return getBackgroundService();
};

export const getCurrentBackgroundSafely = async (selectedSpot = null) => {
    try {
        const backgroundService = await getBackgroundServiceInstance();
        const currentBackground = await backgroundService.getCurrentBackground();
        return {
            success: true,
            locationId: currentBackground.locationId,
            backgroundService,
            currentBackground
        };
    } catch (error) {
        console.error('Error getting current background, using fallback:', error);
        return {
            success: false,
            locationId: selectedSpot?.id || selectedSpot?.loc || selectedSpot?.background || '1',
            backgroundService: null,
            currentBackground: null,
            error
        };
    }
};
